export default "__VITE_ASSET__D1E9$wqZ__"